/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

export const RadioUnitLogBundle = () => {
    const dispatch = useStoreDispatch();
    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);

    const onInputChange = (name: string, value: string) => {
        if (!value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "RU ID is required!" }));
            return;
        }
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
    };

    const onRadioChange = (value: string) => {
        dispatch(setScheduledTask({ radiounitLogRequest: value }));
    };

    const onBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (!value) {
            dispatch(setErrorMsg({ ...errorMsg, [name]: "RU ID is required!" }));
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <p className="text-sm font-medium">Issue a RU Log Bundle command</p>
            <div className="flex flex-col gap-2">
                <p className="text-sm text-muted-foreground">Request RU Log Bundle</p>
                <div className="flex items-center gap-8">
                    {[
                        { value: "RU_LOG_START", label: "Start" },
                        { value: "RU_LOG_STOP", label: "Stop" },
                    ].map((opt) => (
                        <label key={opt.value} className="flex items-center gap-1.5 cursor-pointer text-sm">
                            <input
                                type="radio"
                                name="radiounitLogRequest"
                                value={opt.value}
                                checked={(scheduledtasks?.radiounitLogRequest || "RU_LOG_START") === opt.value}
                                onChange={() => onRadioChange(opt.value)}
                                style={{ accentColor: "var(--primary)" }}
                            />
                            {opt.label}
                        </label>
                    ))}
                </div>
            </div>
            <div>
                <InputField
                    label="RU ID"
                    name="radiounitId"
                    value={scheduledtasks?.radiounitId ?? ""}
                    required
                    onChange={onInputChange}
                    onBlur={onBlurHandler}
                    placeholder="Enter RU ID"
                />
            </div>
        </div>
    );
};